var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { C as Component } from "./utilities-Da0sjanJ.js";
const _DialogOpenEvent = class _DialogOpenEvent extends CustomEvent {
  constructor() {
    super(_DialogOpenEvent.eventName);
  }
};
__publicField(_DialogOpenEvent, "eventName", "dialog:open");
let DialogOpenEvent = _DialogOpenEvent;
class ToggleOverlay extends Component {
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  showDialog(data, event) {
    event.preventDefault();
    event.stopPropagation();
    const dialog = document.querySelector(`${data.targetDialog}`);
    if (!dialog || dialog.open) {
      return;
    }
    dialog.showDialog();
    this.dispatchEvent(new DialogOpenEvent());
  }
}
if (!customElements.get("toggle-overlay")) {
  customElements.define("toggle-overlay", ToggleOverlay);
}
